import type {
	CustomItem,
	DropFaqSectionType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropFaqSection = (
	item: Item | CustomItem
): item is DropFaqSectionType => {
	return !!(item && item.__typename === 'Drop_FAQ_Section');
};
